module.exports = __webpack_public_path__ + "img/first_access.9555ee3f.svg";